<template>
    <ListeMouvementFiche/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeMouvementFiche from "@/components/GesCom/MouvementFiche/ListeMouvementFiche.vue";

    export default defineComponent({
      name: "ListeMouvementFichePage",
      components: {
        ListeMouvementFiche,
      },
    });
  </script>